<template>
  <div class="main-block">
    <div :class="['lists', { 'observed-element': adaptive.isMobile }]">
      <list-item
        v-for="(list, i) in FOOTER_MENU"
        :key="i"
        :list="list"
        @link-click="onLinkClick"
        @section-toggle="onSectionToggle"
      />
    </div>

    <div class="logo container">
      <a ref="logo" href="/" @click.prevent="onLogoClick">
        <f-sprite-icon :icon-link="$options.icons.IconLogo" />
      </a>
      <span>Интернет-магазин яркой<br>и доступной одежды для всей семьи</span>
    </div>

    <div class="contacts container">
      <div class="title">
        Контакты
      </div>
      <ui-link
        class="main-block__tel"
        href="tel:+78007700101"
        @click="gtmEvents.phoneNumberClick"
      >
        8 800 770 01 01
      </ui-link>
      Мы принимаем звонки c 7:00 до 22:00 (мск).<br>
      Звонок по России бесплатный.
      <ui-link
        class="main-block__mail"
        href="mailto:helpme@fundayshop.com"
      >
        helpme@fundayshop.com
      </ui-link>

      <client-only>
        <mobile-apps
          v-if="!adaptive.isMobile"
          class="main-block__mobile-apps"
        />
      </client-only>
    </div>

    <social-networks class="container socials" />

    <client-only>
      <div
        v-if="adaptive.isMobile"
        class="container"
      >
        <mobile-apps class="main-block__mobile-apps" />
      </div>
    </client-only>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import IconLogo from '@/assets/images/logo.multi.svg';
import SocialNetworks from '@/components/common/social-networks/social-networks';
import { createGtmEventsProxy } from '@/gtm/gtm-events-utils';

import { URL_METHOD_MAP } from '../consts';

import ListItem from './list-item';
import MobileApps from './mobile-apps';

export default {
  name: 'main-block',

  components: {
    SocialNetworks,
    ListItem,
    MobileApps,
  },

  inject: {
    gtmEvents: {
      default: createGtmEventsProxy(),
    },
    adaptive: {},
  },

  icons: {
    IconLogo,
  },

  computed: {
    ...mapGetters({
      FOOTER_MENU: 'menu/footerMenu',
    }),
  },

  methods: {
    onLinkClick(url) {
      const method = URL_METHOD_MAP[url];
      this.gtmEvents[method]();
      location?.assign(url);
    },
    onLogoClick() {
      this.gtmEvents.logoClick();
      location.assign('/');
    },
    onSectionToggle(name) {
      this.gtmEvents.mobileSectionClick(name, this.adaptive.isMobile);
    },
  },
};
</script>

<style lang="scss">
.main-block {
  position: relative;

  .logo {
    margin-top: 19px;

    & > span {
      display: block;
      margin-top: 7px;
      color: $gray;
      font-size: 14px;
      line-height: 20px;
    }

    & > a {
      display: block;
      width: 120px;
      height: 24px;
      transform: translateX(-1px);
    }
  }

  .contacts {
    color: $gray;
    font-size: 12px;
    line-height: 20px;

    .title {
      display: none;
      color: $black;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
    }

    .main-block__tel,
    .main-block__mail {
      display: block;
      margin-top: 16px;
      color: $black;
      font-size: 16px;
    }

    .main-block__tel {
      margin-bottom: 4px;
    }
  }

  .socials {
    margin-top: 16px;
  }

  &__mobile-apps {
    margin-top: 16px;

    @include breakpoint("tablet") {
      margin-top: 24px;
    }

    @include breakpoint("desktop") {
      margin-top: 16px;
    }
  }
}

@include breakpoint("tablet") {
  .main-block {
    display: flex;
    flex-wrap: wrap;

    .container {
      min-width: 0;
      margin: 0;
      padding: 0;
    }

    .lists {
      width: 100%;
    }

    .logo,
    .socials {
      padding-left: 32px;
    }

    .logo {
      width: 50%;
      margin-top: 19px;
    }

    .socials {
      width: 50%;
      transform: translateY(-25px);
    }

    .contacts {
      width: 50%;
      margin-top: 22px;
      font-size: 14px;

      .main-block__tel,
      .main-block__mail {
        margin-top: 0;
        margin-bottom: 8px;
      }

      .main-block__tel {
        margin-bottom: 8px;
      }

      .main-block__mail {
        margin-top: 24px;
        margin-bottom: 0;
      }
    }
  }
}

@include breakpoint("desktop") {
  div.main-block {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap;
    max-width: 1288px;
    padding: 56px 32px 0;
    margin: 0 auto;

    .lists {
      display: flex;
      order: 2;
      width: calc(100% / 12 * 5.8);
      flex-wrap: wrap;
      row-gap : 16px;
      column-gap: 24px;
    }

    .title {
      & > span {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .logo,
    .contacts,
    .socials {
      width: auto;
      margin: 0;
      padding: 0;
    }

    .logo {
      order: 1;
      min-width: 184px;
      width: calc((100% / 12) * 2.35);
      margin-right: 72px;
      transform: translateY(-6px);

      & > a {
        width: 184px;
        height: 32px;
        transform: translateX(-2px);
      }

      & > span {
        max-width: 240px;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .contacts {
      position: relative;
      order: 3;
      width: calc((100% / 12) * 2.85);
      transform: none;

      .main-block__tel,
      .main-block__mail {
        margin-top: 16px;
        font-size: 20px;
        line-height: 28px;
      }

      .main-block__tel {
        margin-bottom: 4px;
      }

      .main-block__mail {
        margin-top: 16px;
      }

      .title {
        display: block;
      }
    }
    .socials {
      @include stacking("infront");
      position: absolute;
      bottom: 0;
      left: 32px;
      transform: translateY(0);
    }
  }
}
</style>
